import { Chip, styled } from '@ethings/ui-toolkit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export type LeaseStatus = 'pending' | 'active' | 'finished' | 'no-lease' | 'lease-not-started';

const statusToChipDefinition: Record<LeaseStatus, { label: string; color: 'success' | 'warning' | 'error' | 'default' }> = {
  'pending': { label: 'admin:page.thing-details.lease-management.pending.labels', color: 'warning' },
  'active': { label: 'admin:page.thing-details.lease-management.active.labels', color: 'success' },
  'finished': { label: 'admin:page.thing-details.lease-management.finished.labels', color: 'default' },
  'no-lease': { label: 'admin:page.thing-details.lease-management.no-active-lease.labels', color: 'error' },
  'lease-not-started': { label: 'admin:page.thing-details.lease-management.lease-not-started.labels', color: 'warning' },
};

interface LeaseStatusChipProps {
  status: LeaseStatus;
  fullWidth?: boolean;
}

interface StyledChipProps {
  fullWidth?: boolean;
}

const StyledChip = styled(Chip)<StyledChipProps>(({ theme, fullWidth }) => ({
  height: 'auto',
  '& .MuiChip-label': {
    display: 'block',
    whiteSpace: 'normal',
    padding: theme.spacing(1.5),
  },
  ...(fullWidth ? { width: '100%' } : undefined),
}));

export const LeaseStatusChip: FC<LeaseStatusChipProps> = ({ status, fullWidth }) => {
  const { t } = useTranslation(['admin']);
  const chipDefinition = statusToChipDefinition[status];

  return (
    <StyledChip
      data-testid="lease-status-chip"
      color={chipDefinition.color}
      label={t(chipDefinition.label)}
      fullWidth={fullWidth}
    />
  );
};
